import * as React from 'react';
// import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  root: {
    width: "60px",
    height: "24px",
    padding: "0px"
  },
  switchBase: {
    color: "#818181",
    padding: "1px",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#23bf58"
      }
    }
  },
  thumb: {
    color: "white",
    width: "26px",
    height: "20px",
    borderRadius: "20px",
    margin: "1px"
  },
  track: {
    borderRadius: "20px",
    backgroundColor: "#3522cf",
    opacity: "1 !important",
    "&:after, &:before": {
      color: "white",
      fontSize: "11px",
      position: "absolute",
      top: "6px"
    },
    "&:after": {
      content: "'Staff'",
      left: "5px"
    },
    "&:before": {
      content: "'All'",
      right: "5px"
    }
  },
  checked: {
    color: "#23bf58 !important",
    transform: "translateX(29px) !important"
  }
});
const IOSNameSwitch = (props) => {
  const classes = useStyles();

  return (
    <Switch
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked
      }}
      {...props} 
      inputProps={{ "aria-label": "secondary checkbox" }}
    />
  )
} 
export default IOSNameSwitch